<div class="empty-state" [class]="'empty-state--' + size">
  <div class="empty-state__icon-wrapper">
    <i [class]="icon" class="empty-state__icon"></i>
  </div>

  <h3 class="empty-state__title">{{ title }}</h3>
  <p class="empty-state__message">{{ message }}</p>

  <div *ngIf="actionLabel || secondaryActionLabel" class="empty-state__actions">
    <button
      *ngIf="actionLabel"
      pButton
      [label]="actionLabel"
      [icon]="actionIcon || ''"
      class="p-button-primary"
      (click)="onAction()"
    ></button>

    <button
      *ngIf="secondaryActionLabel"
      pButton
      [label]="secondaryActionLabel"
      class="p-button-outlined p-button-secondary"
      (click)="onSecondaryAction()"
    ></button>
  </div>
</div>
